module.exports = ".block-image-upload img {\n    max-height: 70px !important;\n    padding: 5px !important;\n    margin-bottom: 0px !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/list-product/list-product.component.css
// module id = ./src/app/list-product/list-product.component.css
// module chunks = main